module.exports = __webpack_public_path__ + "static/media/loginbg.88d276f4.png";